
const Index = r => require.ensure([], () => r(require('./Index')), 'groupActivities')
const ActivitiesIntroduce = r => require.ensure([], () => r(require('./activities/index')), 'activities-introduce')
const MyGroupActivities = r => require.ensure([], () => r(require('./myActivities/index')), 'my-activities')
const Helper = r => require.ensure([], () => r(require('./helper/index')), 'helper')
export default {
  path: '/groupActivities',
  component: Index,
  children: [
    {
      // http://0.0.0.0:8080/#groupActivities/activities-introduce
      meta: {
        title: '一起赚'
      },
      path: 'activities-introduce',
      name: 'ActivitiesIntroduce',
      component: ActivitiesIntroduce
    },
    {
      // http://0.0.0.0:8080/#groupActivities/my-activities
      meta: {
        title: '一起赚'
      },
      path: 'my-activities',
      name: 'MyGroupActivities',
      component: MyGroupActivities
    },
    {
      // http://0.0.0.0:8080/#groupActivities/helper
      meta: {
        title: '一起赚'
      },
      path: 'helper',
      name: 'Helper',
      component: Helper
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/groupActivities/router.js